import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { SourceCodeLine, SourceCodeText } from '@atlassian/bitkit-code';
import { media } from '@atlassian/bitkit-responsive';

export const Gutter = styled.td(
  {
    background: token('elevation.surface'),
    borderRight: token('color.border'),
    color: token('color.text.subtlest'),
    fontFamily: token('font.family.code'),
    minWidth: '80px',
    padding: '2px 0',
    textAlign: 'center',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    width: '1%',
    verticalAlign: 'top',
  },
  media.upToMedium(`
    min-width: 0px;

    // && needed to override AK's reset style for td which has padding at 0
    && {
      padding-left: 1em;
      padding-right: 1em;
    }
  `)
);

export const hunkPadding = css({
  'tr:first-child > td': {
    paddingTop: '1em',
  },
  'tr:last-child > td': {
    paddingBottom: '1em',
  },
});

export const SearchSourceCodeLine = styled.td(SourceCodeLine);

export const SearchSourceCodeText = styled.span`
  ${SourceCodeText}
  em {
    font-style: normal;
    color: ${token('color.text.warning.inverse')};
    background: ${token('color.background.warning.bold')};
  }
`;

export const SubtleLink = styled.a({
  color: 'inherit',
  display: 'block',
});
